import React from 'react';
import UtilitiesLists from '../UtilitiesLists/UtilitiesLists';
import UtilitiesSubtitle from '../UtilitiesSubtitle/UtilitiesSubtitle';
import UtilitiesTitle from '../UtilitiesTitle/UtilitiesTitle';
import classes from "./Utilities.module.css";

export default function Utilities() {
    return (
        <section className={classes.Utilities} >
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <UtilitiesTitle />
                    </div>
                    <div className="col-md-12">
                        <UtilitiesSubtitle />
                    </div>
                    <div className="col-md-12">`
                        <UtilitiesLists />
                    </div>
                </div>
                <div className={classes.utilities_footer}>
                    <div className={classes.line}></div>
                    <div className={classes.utilities_footer_frame}>
                        <svg width="64" height="47" viewBox="0 0 64 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.2418 9.77935L12.0062 45.9879" stroke="white" strokeWidth="2.00865" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M1.44995 18.8085L32.4781 39.0856" stroke="white" strokeWidth="2.00865" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M54.7531 1.37963L49.1858 25.5997" stroke="white" strokeWidth="2.00865" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M38.3625 10.3334L60.5357 21.3918" stroke="white" strokeWidth="2.00865" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <div className={classes.line}></div>
                    <div className={classes.utilities_footer_frame}>
                        <svg width="75" height="78" viewBox="0 0 75 78" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M52.7372 64.8004C40.5226 70.3031 25.15 62.6204 18.4015 47.6406C11.6531 32.6607 16.0843 16.0564 28.299 10.5536C40.5136 5.05092 55.8862 12.7336 62.6347 27.7134C69.3831 42.6933 64.9519 59.2976 52.7372 64.8004Z" stroke="white" strokeWidth="2.08865" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M28.2991 10.5532L22.7554 13.0507C10.5396 18.5539 6.10926 35.1572 12.8555 50.1321C19.6017 65.107 34.9729 72.7897 47.1868 67.2873L52.7324 64.789" stroke="white" strokeWidth="2.08865" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M26.2104 15.5925C24.5923 16.5492 22.1475 19.7701 20.7902 23.2709C19.327 27.0448 18.6911 31.1891 18.9866 33.4182" stroke="white" strokeWidth="2.08865" strokeLinecap="round" />
                            <path d="M43.5424 23.1874L46.1393 36.5103" stroke="white" strokeWidth="2.08865" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M30.5288 27.4872L34.4671 38.3892" stroke="white" strokeWidth="2.08865" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M40.7597 43.8827C43.2692 46.862 46.7097 46.9042 50.1551 46.6591C47.2698 48.37 44.9251 50.7489 43.3102 53.7465" stroke="white" strokeWidth="2.08865" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <div className={classes.line}></div>
                </div>
            </div>
        </section>
    )
}
